import React from "react";
import { Route, Routes } from "react-router-dom";
import OrionsBelt from "../components/OrionsBelt/Main";

function Index() {
  return (
    <>
      <Routes>
        <Route path="/" element={<OrionsBelt />} />
      </Routes>
    </>
  );
}

export default Index;
